import ResumeEducationListItem from './ResumeEducationListItem'

export default ResumeEducationListItem
